<template>
  <div class="wrap">


    <slot />


  </div>
</template>

<script>

export default {
  name: "LayoutNone",
  components: {
  }
};
</script>